<template>
  <div>
    <WrapperPreviewCategory customClass="section-preview_lk">
      <GridTable
        :data-rows="serverData"
        :headers="headers.massive"
        :headers-for-rows="headersForRows"
        :loading-data="loadingData"
        :num-cols="headers.countCells"
        :max-table-height="maxTableHeight"
        gap="0"
        ref="npg-table"
        key="form-5-22"
      >
        <template v-for="(item) in headersForRows" v-slot:[item.dataField]="slotData">
          <slot :name="item.dataField" v-bind="slotData">
            <fives-table-cell
                v-if="item.dataField !== 'x1'"
                style="flex: 1 0"
                :disabled="organizationBlocked"
                v-bind="calcPropsForCell(item.dataField, slotData)"
                :cell="calcPropsForCell(item.dataField, slotData)"
                @open-dialog="openDialog($event, slotData.row[item.dataField].name, calcPropsForCell(item.dataField, slotData), slotData.row)"
            />
            <template v-else>
              {{ slotData.row[item.dataField] ? slotData.row[item.dataField].data : slotData.row.text }}
            </template>
            <v-btn small icon @click="openTooltip(slotData.row[item.dataField].name)" v-if="slotData.row[item.dataField]">
              <v-icon
                :size="15"
                class="grey-light-color__important "
              >
                mdi-information
              </v-icon>
            </v-btn>
          </slot>
        </template>
      </GridTable>
    </WrapperPreviewCategory>
    <tooltip-forms5-dialog
      ref="tooltip-dialog"
      :data-field="dataFieldTooltip"
    >
    </tooltip-forms5-dialog>
    <appeal-dialog
      ref="appeal-dialog"
      :appeal-id="appealId"
      :file-id="fileId"
      :appeal="appealCell"
      :value="appealValue"
      :appeal-info="appealInfo"
      @saved-value="saveValue($event)"
      @closing-dialog="closingAppealDialog"
    ></appeal-dialog>
  </div>
</template>

<script>
import GridTable from "@/components/GridTable/GridTable";
import form522 from "./configs/form5-22";
import WrapperPreviewCategory from "@/components/wrappers/WrapperPreviewCategory";
import {headerTooltipFunctions} from "@/mixins/forms5/headerTooltip";
import tooltipForms5Dialog from "@/components/Dialogs/tooltipForms5Dialog";
import {setAppealFromOneToFourDialog} from "@/mixins/forms5/appealDialogF1-4";
import appealDialog from "@/components/Dialogs/appealForms5_1-4Dialog.vue";
import {fiveFormsMixin} from "@/mixins/formUsl";
import Form5Controller from "@/controllers/Organizations/Form5Controller";
import {mapGetters} from "vuex";
import FivesTableCell from "@/components/fields/fivesTableCell.vue";

export default {
  name: "form22",
  mixins: [headerTooltipFunctions, setAppealFromOneToFourDialog, fiveFormsMixin],
  components: {
    FivesTableCell,
/*FivesTableCell,*/ WrapperPreviewCategory, GridTable, tooltipForms5Dialog, appealDialog},
  props: {
    chosenChildOrg: {
      type: Object,
      required: true,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      serverData: [],
      loadingData: false,
      changingHeaders: false,
      headers: form522,
      loadingMenu: {value: false, id: ''},
      full: false
    }
  },
  created() {
    if (this.get_spr_data_usl_loading === false)
      this.loadingDataTable();
  },
  watch: {
    getChosenOrgId() {
      this.loadingDataTable();
    }
  },
  computed: {
    ...mapGetters('spr', {getChosenOrgId: 'getChosenOrgId'}),
    maxTableHeight() {
      return window.innerHeight - 225 + 'px'
    },
    headersForRows() {
      return this.headers.massive.filter(el => el.variable).map(el => {
        return {
          ...el,
          styles: (row) => {
            if (el.dataField !== 'npg')
              return row.uslName ? 'display: none;' : 'justify-content: unset; text-align: center; '
            else
              return ''
          },
          colsDataCalc: (row) => {
            if (el.dataField !== 'npg')
              return 1;
            else
              return row.uslName ? 7 : 1;
          },
          props: (row, cell, loading) => {
            return {
              value: row[cell.dataField],
              title: '',
              cell: cell,
              id: row.id,
              row: row,
              loading: loading,
            }
          }
        }
      })
    },
  },
  methods: {
    loadFullInfo() {
      this.full = !this.full;
      this.loadingDataTable()
    },

    calcPropsForCell(dataField, slotData) {
      // console.log(dataField, slotData, slotData.row.dataId)
      return {
        value: slotData.row[dataField].data,
        title: '',
        cell: {dataField: slotData.row[dataField].name},
        id: slotData.row.dataId,
        rowId: slotData.row.id,
        row: slotData.row,
        loading: this.loading,
        template: (v) => {
          if (v == null || v === 'н.д.')
            return 'н.д.';
          const dot = v.indexOf(',');
          if (dot !== -1) {
            const newV = v.slice(0, dot) + '.' + v.slice(dot + 1, dot + 2);
            return Intl.NumberFormat('ru-RU').format(Number.parseFloat(newV));
          } else
            return Intl.NumberFormat('ru-RU').format(Number.parseFloat(v));
        }
      }
    },

    async loadingDataTable() {
      this.loadingData = true;
      this.serverData = [];
      try {
        const array = await Form5Controller.getForm('part22', this.full, false, this.chosenChildOrg?.id);
        
        const obj1 = {
          id: 1,
          dataId: array['id'],
          orgId: array['orgId'],
          text: 'Бакалавриат',
          qredb20Vp1: {name: 'qredb20Vp1', data: array['qredb20Vp1']},
          qredb21Vp1: {name: 'qredb21Vp1', data: array['qredb21Vp1']},
          qredb22Vp1: {name: 'qredb22Vp1', data: array['qredb22Vp1']},
          qesfb20Vp1: {name: 'qesfb20Vp1', data: array['qesfb20Vp1']},
          qesfb21Vp1: {name: 'qesfb21Vp1', data: array['qesfb21Vp1']},
          qesfb22Vp1: {name: 'qesfb22Vp1', data: array['qesfb22Vp1']},
          qpsfb20Vp1: {name: 'qpsfb20Vp1', data: array['qpsfb20Vp1']},
          qpsfb21Vp1: {name: 'qpsfb21Vp1', data: array['qpsfb21Vp1']},
          qpsfb22Vp1: {name: 'qpsfb22Vp1', data: array['qpsfb22Vp1']}
        }
        const obj2 = {
          id: 2,
          dataId: array['id'],
          orgId: array['orgId'],
          text: 'Специалитет',
          qredb20Vp1: {name: 'qreds20Vp1', data: array['qreds20Vp1']},
          qredb21Vp1: {name: 'qreds21Vp1', data: array['qreds21Vp1']},
          qredb22Vp1: {name: 'qreds22Vp1', data: array['qreds22Vp1']},
          qesfb20Vp1: {name: 'qesfs20Vp1', data: array['qesfs20Vp1']},
          qesfb21Vp1: {name: 'qesfs21Vp1', data: array['qesfs21Vp1']},
          qesfb22Vp1: {name: 'qesfs22Vp1', data: array['qesfs22Vp1']},
          qpsfb20Vp1: {name: 'qpsfs20Vp1', data: array['qpsfs20Vp1']},
          qpsfb21Vp1: {name: 'qpsfs21Vp1', data: array['qpsfs21Vp1']},
          qpsfb22Vp1: {name: 'qpsfs22Vp1', data: array['qpsfs22Vp1']}
        }
        const obj3 = {
          id: 3,
          dataId: array['id'],
          orgId: array['orgId'],
          text: 'Магистратура',
          qredb20Vp1: {name: 'qredm20Vp1', data: array['qredm20Vp1']},
          qredb21Vp1: {name: 'qredm21Vp1', data: array['qredm21Vp1']},
          qredb22Vp1: {name: 'qredm22Vp1', data: array['qredm22Vp1']},
          qesfb20Vp1: {name: 'qesfm20Vp1', data: array['qesfm20Vp1']},
          qesfb21Vp1: {name: 'qesfm21Vp1', data: array['qesfm21Vp1']},
          qesfb22Vp1: {name: 'qesfm22Vp1', data: array['qesfm22Vp1']},
          qpsfb20Vp1: {name: 'qpsfm20Vp1', data: array['qpsfm20Vp1']},
          qpsfb21Vp1: {name: 'qpsfm21Vp1', data: array['qpsfm21Vp1']},
          qpsfb22Vp1: {name: 'qpsfm22Vp1', data: array['qpsfm22Vp1']}
        }
        this.serverData.push(obj1, obj2, obj3);
        this.loadingData = false;
      } catch (e) {
        this.loadingData = false;
      }
    },
    saveValue(e) {
      console.log(e)
      for (let ss in this.serverData[0]){
        if (this.serverData[0][ss].name === e.dataField) {
          console.log(this.serverData[0][ss], ss)
          this.serverData[0][ss].data = {
            oldValue: e.oldValue,
            newValue: e.newValue,
            id: e.id,
            accept: e.accept
          };
          this.$refs["appeal-dialog"].closeDialog();
          return
        }
      }
      for (let ss in this.serverData[1]){
        if (this.serverData[1][ss].name === e.dataField) {
          console.log(this.serverData[1][ss], ss)
          this.serverData[1][ss].data = {
            oldValue: e.oldValue,
            newValue: e.newValue,
            id: e.id,
            accept: e.accept
          };
          this.$refs["appeal-dialog"].closeDialog();
          return
        }
      }
      for (let ss in this.serverData[2]){
        if (this.serverData[2][ss].name === e.dataField) {
          this.serverData[2][ss].data = {
            oldValue: e.oldValue,
            newValue: e.newValue,
            id: e.id,
            accept: e.accept
          };
          this.$refs["appeal-dialog"].closeDialog();
          return
        }
      }
    }
  },
}
</script>

<style scoped>

</style>